import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavigationBar.css";
import styled from "styled-components";
import imaA from "../img/logooo.png";
import n from "../img/phone.png";

const HeaderWrapper = styled.header`
  width: 100%;
  direction: rtl;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
`;

export const NavigationBar = () => {
  const location = useLocation();

  const closeMobileMenu = () => {
    const menu = document.querySelector(".modern-mobile-menu");
    const toggle = document.querySelector(".modern-toggle");

    if (menu) {
      menu.classList.remove("active");
    }

    if (toggle) {
      toggle.classList.remove("active");
    }

    setTimeout(() => {
      window.scrollTo({
        top: 300,
        behavior: "smooth",
      });
    }, 100);
  };

  const handleNavigation = () => {
    const menu = document.querySelector(".modern-mobile-menu");
    const toggle = document.querySelector(".modern-toggle");

    if (menu) {
      menu.classList.remove("active");
    }

    if (toggle) {
      toggle.classList.remove("active");
    }

    setTimeout(() => {
      window.scrollTo({
        top: 300,
        behavior: "smooth",
      });
    }, 100);
  };

  const toggleMobileMenu = (e) => {
    e.currentTarget.classList.toggle("active");

    const menu = document.querySelector(".modern-mobile-menu");

    if (menu) {
      menu.classList.toggle("active");
    }
  };

  return (
    <HeaderWrapper>

      <div className="modern-navbar">

        {/* LOGO */}

        <Link
          to="/"
          className="modern-logo"
          onClick={handleNavigation}
        >
          <img
            src={imaA}
            alt="לוגו האתר"
          />
        </Link>


        {/* DESKTOP MENU */}

        <nav className="modern-menu">

          <Link
            to="/"
            className="modern-link"
            onClick={handleNavigation}
          >
            <span>בית</span>
          </Link>

          <Link
            to="/About"
            className="modern-link"
            onClick={handleNavigation}
          >
            <span>אודות</span>
          </Link>

          <Link
            to="/Mysite"
            className="modern-link"
            onClick={handleNavigation}
          >
            <span>עבודות שלנו</span>
          </Link>

          <Link
            to="/Contact"
            className="modern-link"
            onClick={handleNavigation}
          >
            <span>יצירת קשר</span>
          </Link>

        </nav>


        {/* PHONE */}

        <a
          href="tel:0506831839"
          className="modern-phone"
        >
          <span className="phone-icon">

            <img
              src={n}
              alt="טלפון"
            />

          </span>

          <span className="phone-content">

            <small>
              לייעוץ חינם
            </small>

            <strong>
              צור קשר
            </strong>

          </span>

        </a>


        {/* MOBILE HAMBURGER */}

        <button
          type="button"
          className="modern-toggle"
          aria-label="פתיחת תפריט"
          onClick={toggleMobileMenu}
        >

          <span></span>
          <span></span>
          <span></span>

        </button>

      </div>


      {/* MOBILE MENU */}

      <div className="modern-mobile-menu">

        <Link
          to="/"
          onClick={closeMobileMenu}
        >
          בית
        </Link>

        <Link
          to="/About"
          onClick={closeMobileMenu}
        >
          אודות
        </Link>

        <Link
          to="/Mysite"
          onClick={closeMobileMenu}
        >
          עבודות שלנו
        </Link>

        <Link
          to="/Contact"
          onClick={closeMobileMenu}
        >
          יצירת קשר
        </Link>

        <a
          href="tel:0506831839"
          className="mobile-phone"
          onClick={closeMobileMenu}
        >

          <img
            src={n}
            alt="טלפון"
          />

          התקשרו עכשיו

        </a>

      </div>

    </HeaderWrapper>
  );
};

export default NavigationBar;